var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1.01001 11.8711V18.2111C1.01001 19.2111 1.82001 20.0211 2.82001 20.0211H4.63001C5.63001 20.0211 6.44001 19.2111 6.44001 18.2111V13.6811C6.44001 12.6811 5.63001 11.8711 4.63001 11.8711H1.01001Z",
    fill: "#91BC68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M22.91 11.8711H19.29C18.29 11.8711 17.48 12.6811 17.48 13.6811V18.2111C17.48 19.2111 18.29 20.0211 19.29 20.0211H21.1C22.1 20.0211 22.91 19.2111 22.91 18.2111V11.8711Z",
    fill: "#91BC68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.91 11.8702H19.29C18.29 11.8702 17.48 12.6802 17.48 13.6802V18.2102C17.48 19.2102 18.29 20.0202 19.29 20.0202H21.1C22.1 20.0202 22.91 19.2102 22.91 18.2102V11.8702ZM22.91 11.8702C22.91 5.87025 18.05 1.00025 12.04 1.00025C12.01 1.00025 11.98 1.00025 11.95 1.00025C5.95 0.960247 1.05 5.79025 1 11.7902C1 11.8202 1 11.8402 1 11.8702V18.2102C1 19.2102 1.81 20.0202 2.81 20.0202H4.62C5.62 20.0202 6.43 19.2102 6.43 18.2102V13.6802C6.43 12.6802 5.62 11.8702 4.62 11.8702H1.01",
    stroke: "#74B743",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.91 18.2109V20.9309C22.91 22.9309 21.29 24.5509 19.29 24.5509H12.78",
    stroke: "#74B743",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/Headphone.341c0fb58e6639f7391560309b694db1.svg";
export { ForwardRef as ReactComponent };